<template>
  <div class="animated fadeIn step-container">
  
    <div class="row">

      <div class="col-md-8 offset-md-2">
        <h2 v-if="$route.query.action === 'edit'">{{$t('message.doctor_header.title_edit')}}</h2>
        <h2 v-else>{{$t('message.doctor_header.title_new')}}</h2>
        <step :currentStep="4" :maxStep="5" @step_clicked='gotoPage'>
          <div slot='1'>{{$t('message.doctor_header.personal_info')}}</div>
          <div slot='2'>{{$t('message.doctor_header.experience')}}</div>
          <div slot='3'>{{$t('message.doctor_header.schedules')}}</div>
          <div slot='4'>{{$t('message.doctor_header.education')}}</div>
          <div slot='5'>{{$t('message.doctor_header.other_info')}}</div>
        </step>
      </div>

      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">{{$t('message.doctor_header.education')}}</h4>

        <!-- Education -->
        <div class="row">
          <div class="col-12">
           <h6>{{$t('message.doctor_education.education_info')}}</h6>
          </div>

          <div class="col-12"> <p class="step-subheader">{{$t('message.doctor_education.education_info_th')}}</p>
          </div>
        </div>

        <doctor-array-input :dataset.sync="doctor.th.educations" 
                            @update:dataset="v => doctor.th.educations = v"
                            :description="$t('message.doctor_education.education_info_th')" >
        </doctor-array-input>
        
        <div class="row">
          <div class="col-12">
            <p class="step-subheader">{{$t('message.doctor_education.education_info_en')}}</p>
          </div>
        </div>

        <doctor-array-input :dataset.sync="doctor.en.educations" 
                            @update:dataset="v => doctor.en.educations = v"
                            :description="$t('message.doctor_education.education_info_en')" />
        <!-- End Education -->

        <div class="form-divider"></div>

        <!-- Certification -->
        <div class="row">
          <div class="col-12">
            <h6>{{$t('message.doctor_education.certifications')}}</h6>
          </div>
          <div class="col-12">
            <p class="step-subheader">{{$t('message.doctor_education.certifications_th')}}</p>
          </div>
        </div>

        <doctor-array-input :dataset="doctor.th.certifications" :description="$t('message.doctor_education.certifications_th')" />

        <div class="row">
          <div class="col-12">
            <p class="step-subheader">{{$t('message.doctor_education.certifications_en')}}</p>
          </div>
        </div>

        <doctor-array-input :dataset.sync="doctor.en.certifications" :description="$t('message.doctor_education.certifications_en')" />
        <!-- End Certification -->

        <div class="form-divider"></div>

        <!-- License Number -->
        <div class="row">
          <div class="col-12">
            <h6>{{$t('message.doctor_education.license_number')}}</h6>
          </div>
          <div class="col-12">
            <div class="form-group">
              <input type="text" class="form-control" 
                                 v-model='doctor.license_number'
                                 :placeholder="$t('message.doctor_education.license_number')">
            </div>
          </div>
        </div>
        <!-- End License Number -->

        <div class="form-divider"></div>

        <!-- Board -->
        <div class="row">
          <div class="col-12">
            <h6>{{$t('message.doctor_education.professional_memberships')}}</h6>
          </div>

          <div class="col-12">
            <p class="step-subheader">{{$t('message.doctor_education.professional_memberships_th')}}</p>
          </div>
        </div>

        <doctor-array-input :dataset="doctor.th.professional_memberships" :description="$t('message.doctor_education.professional_memberships_th')" />
        
        <div class="row">
          <div class="col-12">
            <p class="step-subheader">{{$t('message.doctor_education.professional_memberships_en')}}</p>
          </div>
        </div>

        <doctor-array-input :dataset.sync="doctor.en.professional_memberships" :description="$t('message.doctor_education.professional_memberships_en')" />
        <!-- End Board -->

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg" @click="back">{{$t('action_message.back')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
            <button v-if="$route.query.action === 'edit'" class="btn btn-delete btn-right btn-lg" @click="deleteDoctor">{{$t('action_message.remove')}}</button>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import router from '@/router'
import Step from '@/components/StepBar'
import DoctorArrayInput from '@/components/DoctorArrayInput'
import DoctorMixin from './mixin'

export default {
  name: 'DoctorEditStep4',
  mixins: [DoctorMixin],
  components: {
    Step,
    DoctorArrayInput
  },
  data () {
    return {
      doctor: {
        license_number: '',
        th: {
          educations: [],
          certifications: [],
          professional_memberships: []
        },
        en: {
          educations: [],
          certifications: [],
          professional_memberships: []
        }
      }
    }
  },
  methods: {
    back () {
      router.go(-1)
    },
    saveAndContinue () {
      let routeData = { path: this.next_uri(4), query: {action: this.$route.query.action} }
      this.$http.put(this.doctor_uri,
        // data
        {
          th: this.doctor.th,
          en: this.doctor.en,
          license_number: this.doctor.license_number
        },
        // options
        {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(res => {
          if (res.body.status === 'success') {
            this.$toastr.success(this.$t('action_message.save_success'))
            router.push(routeData)
          }
        })
    },
    async deleteDoctor () {
      if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
        this.$http.delete(this.$APP_CONFIG.api.admin.doctors(this.doctor_key)).then(res => {
          if (res.body) {
            router.push({path: '/clinic/doctors'})
          }
        })
      }
    }
  },
  created () {
    var self = this
    this.$http.get(this.doctor_uri).then(res => {
      let _doctor = Object.assign({}, res.body.data)
      // use push data to old array for data reactivity of child component
      let fields = ['educations', 'certifications', 'professional_memberships']
      fields.forEach(field => {
        if (_doctor.th[field]) {
          _doctor.th[field].forEach(v => {
            self.doctor.th[field].push(v)
          })
        }

        if (_doctor.en[field]) {
          _doctor.en[field].forEach(v => {
            self.doctor.en[field].push(v)
          })
        }

        self.doctor.license_number = _doctor.license_number
      })
    }, errorResponse => {
      console.error(errorResponse)
    })
  }
}
</script>

<style lang="scss">
@import "../../../assets/base_container";
.step-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.step-subheader{
  margin-bottom: 7px;
}
.step-container{
  h6{
    color: #5e5e5e;
    margin-bottom: 12px;
    font-size: 1.2rem;
  }
  .step-body{
    background-color: #fff;
    padding-top: 10px;
  }
}
.form-divider{
  height: 1px;
  border: 1px dashed #ddd;
  margin: 10px 0;
}
.gender-select{
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  .form-check{
    margin-bottom: 0px;
  }
  .form-check-inline + .form-check-inline{
    margin-left: 2.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// Education.vue?44d768d2